import tippy, { inlinePositioning } from 'tippy.js'

export default function () {
  tippy('.js-tippy', {
    allowHTML: true,
    appendTo: document.body,
    inlinePositioning: true,
    plugins: [inlinePositioning],
    theme: 'port-of-quebec',
    placement: 'top',
    popperOptions: {
      strategy: 'fixed',
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            altAxis: true,
            tether: false,
          },
        },
      ],
    },
    aria: {
      content: 'auto',
      expanded: 'auto',
    },
    content(reference) {
      const id = reference.getAttribute('data-template')
      const template = document.getElementById(id)
      return template.innerHTML
    },
  })
}
